module.exports = __webpack_public_path__ + "img/Icon Datacomm.aa01c226.png";